import React from "react";
import logoImage from "../../assets/img/logo-green.svg";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import style from "../../assets/jss/disal-main/Layouts/Login";
const LoginImage = props => (
  <Grid item xs={12} sm={12} md={8} lg={8} xl={9}>
    <div className={props.classes.contentPresentation}>
      <div className={props.classes.overlay}>
        <div className={props.classes.overlayContent}></div>
      </div>
      <img
        className={props.classes.logo}
        src={logoImage}
        alt="Logo de la compañia"
      />
      <div className={props.classes.slogan}>
        <p>
          Gestiona la recolección de residuos y patios con información oportuna
        </p>
        <hr />
      </div>
      <p className={props.classes.footerLogin}>UN PRODUCTO DE ENFASYS</p>
    </div>
  </Grid>
);
export default withStyles(style)(LoginImage);
